
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { SidebarMenuItem } from '@/utils/sidebarMenuItems';

interface AdminNavBarProps {
  navItems: SidebarMenuItem[];
  onLogout: () => void;
  activeTab?: string;
}

const AdminNavBar: React.FC<AdminNavBarProps> = ({ 
  navItems, 
  onLogout,
  activeTab = 'dashboard'
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleNavClick = (url: string) => {
    navigate(url);
  };
  
  return (
    <nav className="bg-primary-blue border-t border-blue-600">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-wrap gap-2 py-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.url || activeTab === item.url.split('/').pop();
            
            return (
              <Button
                key={item.url}
                variant={isActive ? "default" : "ghost"}
                size="sm"
                onClick={() => handleNavClick(item.url)}
                className={`flex items-center gap-2 ${
                  isActive 
                    ? "bg-white text-primary-blue" 
                    : "text-white hover:bg-primary-blue/20"
                }`}
              >
                {Icon && <Icon className="h-4 w-4" />}
                {item.title}
              </Button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default AdminNavBar;
